import { useEffect, useState } from 'react';
import { ErrorState, LoadingState } from '../../muster';

/**
 * Ein GA-Schema (Funktionsschema, Topologie, ASP-Blatt) als SVG vom Server —
 * dasselbe Blob-Muster wie `koordination/Vorschaubild.tsx`: Ein
 * `<img src="/api/...">` sendet kein Bearer-Token und würde mit 401
 * abgewiesen, deshalb der Umweg über `fetch`, Blob und eine Objekt-URL.
 *
 * `laden` liefert die Objekt-URL fertig (siehe `api.msrSchema*Svg`) — diese
 * Komponente kennt den Pfad nicht, nur die Ladefunktion, damit sie für alle
 * drei Schemenarten gleich bleibt.
 */
export function SchemaBild({
  laden, titel, schluessel,
}: {
  laden: () => Promise<string>;
  titel: string;
  /** Ändert sich der Schlüssel (z. B. die Anlage), wird neu geladen. */
  schluessel: string;
}) {
  const [adresse, setAdresse] = useState<string | null>(null);
  const [fehler, setFehler] = useState<string | null>(null);
  // TM-8c: „Erneut versuchen“ lädt neu - vorher setzte es nur den Fehler zurück, der Kreisel blieb stehen.
  const [versuch, setVersuch] = useState(0);

  useEffect(() => {
    let abgebrochen = false;
    let eigeneAdresse: string | null = null;

    setAdresse(null);
    setFehler(null);

    laden()
      .then((url) => {
        if (abgebrochen) { URL.revokeObjectURL(url); return; }
        eigeneAdresse = url;
        setAdresse(url);
      })
      .catch((e) => {
        if (!abgebrochen) setFehler(e instanceof Error ? e.message : String(e));
      });

    return () => {
      abgebrochen = true;
      if (eigeneAdresse) URL.revokeObjectURL(eigeneAdresse);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schluessel, versuch]);

  if (fehler) {
    return (
      <ErrorState
        meldung={`${titel} konnte nicht geladen werden.`}
        technisch={fehler}
        beiErneutVersuchen={() => setVersuch((v) => v + 1)}
      />
    );
  }

  if (!adresse) return <LoadingState text={`${titel} wird abgerufen …`} art="spinner" />;

  return (
    <div className="tabellenrahmen" style={{ padding: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 6 }}>
        <button type="button" className="m-knopf"
          onClick={() => window.open(adresse, '_blank')}>
          In neuem Fenster
        </button>
      </div>
      <img src={adresse} alt={titel} style={{ maxWidth: '100%', display: 'block' }} />
    </div>
  );
}
